import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {changePlayOption} from "store/actions/playOption";
import {
  closeSave,
  hideAvatars,
  stopRecord,
  switchHand,
  switchToPicture,
  switchToVideo,
  takeSelfie,
  turnOffSelfieMode,
  turnOnSelfieMode,
} from "store/actions/selfie";
import View from "./View";

const Container = ({isIPXMode}) => {
  const dispatch = useDispatch();
  const selfie = useSelector(state => state.selfie);
  const isPicture = useSelector(state => state.selfie.type) === "PICTURE";
  const isVideo = useSelector(state => state.selfie.type) === "VIDEO";
  const isRecording =
    useSelector(state => state.selfie.action.command) === "TAKE_SELFIE";

  const onClickSelfieModeBtn = () => {
    dispatch(turnOnSelfieMode());
  };

  const onClickCloseBtn = () => {
    dispatch(turnOffSelfieMode());
    dispatch(changePlayOption(null));
  };

  const onClickSelfieShootBtn = () => {
    if (isPicture) {
      dispatch(takeSelfie());
    }

    if (isVideo) {
      if (!isRecording) {
        dispatch(takeSelfie());
      } else {
        dispatch(stopRecord());
      }
    }
  };

  const onClickPictureBtn = () => {
    dispatch(switchToPicture());
  };

  const onClickVideoBtn = () => {
    dispatch(switchToVideo());
  };

  const onClickAvatarHideBtn = () => {
    dispatch(hideAvatars());
  };

  const onClickSaveCloseBtn = () => {
    dispatch(closeSave());
  };

  const onClickSwitchBtn = () => {
    dispatch(switchHand());
  };

  return (
    <View
      selfie={selfie}
      onClickSelfieModeBtn={onClickSelfieModeBtn}
      onClickSelfieShootBtn={onClickSelfieShootBtn}
      onClickPictureBtn={onClickPictureBtn}
      onClickVideoBtn={onClickVideoBtn}
      onClickAvatarHideBtn={onClickAvatarHideBtn}
      onClickCloseBtn={onClickCloseBtn}
      onClickSaveCloseBtn={onClickSaveCloseBtn}
      onClickSwitchBtn={onClickSwitchBtn}
      isIPXMode={isIPXMode}
    />
  );
};
export default Container;
